export default __webpack_public_path__ + "static/dairy-free-taste-3-mobile-f8992e10b841821eac409f69966e801d.png";